export const STATUSS = {
    MELNRAKSTS: 'melnraksts',
    PARSKATISANA: 'pārskatīšanā',
    APSTIPRINATS: 'apstiprināts',
    ARHIVETS: 'arhivēts'
};

export const getNovertejumsColor = (value, vivid = false) => {
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return '';
    if (numValue <= 5) return vivid ? '#00ca2f' : '#d4edda';
    if (numValue >= 6 && numValue <= 8) return vivid ? '#ffc400' : '#fff3cd';
    if (numValue >= 9 && numValue <= 12) return vivid ? '#f36900' : '#ffd4b3';
    if (numValue >= 13) return vivid ? '#d3000e' : '#ee6f78';
    return '';
};

export const getStatusBadgeColor = (statuss) => {
    const statusColors = {
        [STATUSS.MELNRAKSTS]: 'secondary',
        [STATUSS.PARSKATISANA]: 'warning',
        [STATUSS.APSTIPRINATS]: 'success',
        [STATUSS.ARHIVETS]: 'dark'
    };
    return statusColors[statuss] || 'secondary';
};

export const getRiskLevel = (value) => {
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return { label: '-', color: '' };
    if (numValue <= 5) return { label: 'Zems risks', color: '#d4edda' };
    if (numValue >= 6 && numValue <= 14) return { label: 'Vidējs risks', color: '#fff3cd' };
    if (numValue >= 15) return { label: 'Augsts risks', color: '#f8d7da' };
    return { label: '-', color: '' };
};

export const isNovertejumsEditableByUser = (novertejums, userTiesibas) => {
    if (!novertejums) return false;
    if (novertejums.dzusb_ir_arhivets) return false;
    if (novertejums.statuss === STATUSS.APSTIPRINATS || novertejums.statuss === STATUSS.ARHIVETS) return false;
    if (novertejums.statuss === STATUSS.MELNRAKSTS) return userTiesibas?.includes('SATECES_BASEINI_VERTETAJS');
    return userTiesibas?.includes('SATECES_BASEINI_VERTETAJS_EKSPERTS');
};

export const canDeleteNovertejums = (novertejums, userTiesibas) => {
    if (!novertejums) return false;
    if (novertejums.dzusb_ir_arhivets) return false;
    if (novertejums.statuss === STATUSS.APSTIPRINATS || novertejums.statuss === STATUSS.ARHIVETS) {
        return userTiesibas?.includes('SATECES_BASEINI_DZEST');
    }
    return isNovertejumsEditableByUser(novertejums, userTiesibas);
};

export const parseListResult = (result) => {
    const data = result?.list || result?.payload?.list || result?.rows || result || [];
    return Array.isArray(data) ? data : [];
};
